import api from "../api-backend";

class ProfessorService {

    getProfessors = async (page, size, query, sort) => {
        const response = await api.get(`/engine/professorat?query=${query}&rows=${size}&start=${page}&sort=${sort}`)
        return {
            'professors': response.data.response.docs,
            'facetes': response.data.facet_counts.facet_fields,
            'total': response.data.response.numFound
        }
    }

    getProfessor = async (id) => {
        const response = await api.get(`/engine/${id}`)
        return {
            'professor': response.data.response.docs[0],
        }
    }

    getDocenciaProfessor = async (id) => {
        const response = await api.get(`/engine/professor/docencia/${id}`)
        return {
            'docencia': response.data.response.docs,
        }
    }

    getProfessorsParticipantsOrganitzacio = async (query) => {
        const response = await api.get('/engine/organitzacio/professors?query='+query)
        return {
            'professors': response.data.response.docs,
            'length': response.data.response.numFound
        }
    }

    getProfessorsParticipantsAssignatura = async (query) => {
        const response = await api.get('/engine/assignatura/professors/'+query)
        return {
            'professors': response.data.response.docs,
            'length': response.data.response.numFound
        }
    }

    getProfessorsParticipantsTitulacio = async (query) => {
        const response = await api.get('/engine/titulacio/professors/'+query)
        return {
            'professors': response.data.response.docs,
            'length': response.data.response.numFound
        }
    }


}

export default new ProfessorService()
